import { render, staticRenderFns } from "./UserLinkedinConfig.vue?vue&type=template&id=5b4baa93&"
import script from "./UserLinkedinConfig.vue?vue&type=script&lang=js&"
export * from "./UserLinkedinConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports